import { PayloadAction } from '@reduxjs/toolkit';
import { SyfoAppState } from '../state';
import { VehicleNode } from '@syfo/types/vault.types';
import { updateById } from './reducer-utils';

export const addVehicle = (state: SyfoAppState, action: PayloadAction<VehicleNode>) => {
  if (state.currentVault) {
    state.currentVault.data.vehicles.push(action.payload);
  }
};

export const updateVehicle = (state: SyfoAppState, action: PayloadAction<{ id: string; vehicle: Partial<VehicleNode> }>) => {
  if (state.currentVault) {
    updateById(state.currentVault.data.vehicles, action.payload.id, action.payload.vehicle);
  }
};

export const removeVehicle = (state: SyfoAppState, action: PayloadAction<string>) => {
  if (state.currentVault) {
    state.currentVault.data.vehicles = state.currentVault.data.vehicles.filter(v => v.id !== action.payload);
  }
};